<template>
  <div>
    <b-modal :id="modalId"
             size="md"
             centered
             hide-footer
             hide-header
             modal-class="modal-right-pane">
      <LightCourses :selectMode="true"
                    :select-course="selectCourse"
                    @courseSelected="courseSelected"
                    @materialSelected="materialSelected"/>
    </b-modal>
  </div>
</template>

<script>
import LightCourses from "../../pages/instructor/courses/LightCourses.vue"

export default {
  components: {
    LightCourses,
  },
  props: {
    coursePassed: {},
    materialPassed: {},
    selectCourse: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      modalId: 'selectLightCourseMaterial',
    }
  },
  methods: {
    materialSelected(m) {
      this.$emit('selected', m)
      this.$bvModal.hide(this.modalId)
    },
    courseSelected(course) {
      if(!this.selectCourse) return
      this.$emit('courseSelected', course)
      this.$bvModal.hide(this.modalId)
    }
  },

}
</script>






